import Controller from '../abstracts/Controller';
import 'scss-templates/t-register.scss';

export default class RegisterController extends Controller {
  static get COMPONENTS() {
    return [
      'RegistrationComponent',
      'ShowPasswordComponent',
      'DatePickerComponent'
    ];
  }
}
